module.exports = __webpack_public_path__ + "img/M2_MS_11.e5b03ee5.png";